import React from 'react';
import { useState, useEffect } from 'react';
import BasicInformationScreen from '../../screens/Supplier/Registration/BasicInformationScreen';
import CompanyDetailsScreen from '../../screens/Supplier/Registration/CompanyDetailsScreen';
import TechnicalDetailsScreen from '../../screens/Supplier/Registration/TechnicalDetailsScreen';
import RefrencesTestimonialsScreen from '../../screens/Supplier/Registration/RefrencesTestimonialsScreen';
import ManufacturerFormBreadcrumb from '@/js/components/ManufacturerRegistration/ManufacturerFormBreadcrumb';
import { Button } from '@/components/ui/button';
import { ChevronLeft, Menu } from 'lucide-react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';

import UploadCertificates from '@/js/screens/Supplier/Registration/UploadCertificates';
import MachiningInformation from '@/js/screens/Supplier/Registration/MachiningInformation';
import UploadSpecificCert from '@/js/screens/Supplier/Registration/UploadSpecificCert';
import PlantInfromation from '@/js/screens/Supplier/Registration/PlantInfromation';
import { useLocation } from 'react-router-dom';
import AddMachineForm from '@/js/screens/Supplier/Registration/util/AddMachineForm';
import AddPlantForm from '@/js/screens/Supplier/Registration/util/AddPlantForm';
import LeftSidebar from '@/js/components/sidebars/LeftSidebar';
import RightSideBar from '@/js/components/ManufacturerRegistration/RightSideBar';

// Custom useMediaQuery hook for responsive behavior
const useMediaQuery = (query) => {
  const [matches, setMatches] = React.useState(false);

  React.useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);

    const listener = () => setMatches(media.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [query]);

  return matches;
};
const steps = [
  { id: 1, label: 'Basic Information' },
  { id: 2, label: 'Company Details' },
  { id: 3, label: 'Technical Details' },
  { id: 4, label: 'Upload Certificates' },
  { id: 5, label: 'References & Testimonials' },
  { id: 6, label: 'Plant Information' },
  { id: 7, label: 'Machines Information' },
];

const SupplierRegisterPage = () => {
  const [sectionId, setSectionId] = useState(1);
  const responsive = useMediaQuery('(min-width: 1024px)');
  const location = useLocation();
  const [sectionIdentity, setSectionIdentity] = useState(null);

  useEffect(() => {
    // Set the section ID from navigation if it exists
    if (location.state?.sectionId) {
      setSectionId(location.state.sectionId);
    }
  }, [location.state]);
  // Modified to accept both section and identity
  const navigateToSection = (newSectionId, identity = null) => {
    setSectionId(newSectionId);
    setSectionIdentity(identity);
  };
  const getSection = (sectionId) => {
    switch (sectionId) {
      case 1:
        return <BasicInformationScreen setSectionId={navigateToSection} />;
      case 2:
        return <CompanyDetailsScreen setSectionId={navigateToSection} />;
      case 3:
        return <TechnicalDetailsScreen setSectionId={navigateToSection} />;
      case 4:
        return <UploadCertificates setSectionId={navigateToSection} />;
      case 5:
        return <RefrencesTestimonialsScreen setSectionId={navigateToSection} />;
      case 6:
        return <PlantInfromation setSectionId={navigateToSection} />;
      case 7:
        return <MachiningInformation setSectionId={navigateToSection} />;
      case 8:
        return (
          <AddPlantForm
            setSectionId={navigateToSection}
            identity={sectionIdentity}
          />
        );
      case 9:
        return (
          <AddMachineForm
            setSectionId={navigateToSection}
            identity={sectionIdentity}
          />
        );
      default:
        break;
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* Left Sidebar */}
      {responsive ? (
        sectionId !== 7 &&
        sectionId !== 8 &&
        sectionId !== 9 &&
        sectionId !== 6 ? (
          <div className="w-[15%] min-w-[200px] shadow-md">
            <div className="left-sidebar my-10 pl-10 mt-10 pr-3 w-full">
              <LeftSidebar role="supplier" />
            </div>
          </div>
        ) : (
          <div className="w-[80px] min-w-20 shadow-md">
            <div className="left-sidebar mt-10 w-full">
              <LeftSidebar isCompact={true} />
            </div>
          </div>
        )
      ) : (
        <Drawer>
          <DrawerTrigger asChild>
            <Menu size={28} className="cursor-pointer mt-7 ml-5" />
          </DrawerTrigger>
          <DrawerContent>
            <div className="mx-auto w-full max-w-sm">
              <DrawerHeader>
                <DrawerTitle>Menu</DrawerTitle>
              </DrawerHeader>
              <LeftSidebar role="supplier" />
              <DrawerClose asChild>
                <Button variant="outline" className="w-full">
                  Close
                </Button>
              </DrawerClose>
            </div>
          </DrawerContent>
        </Drawer>
      )}

      {/* Main Form Section */}
      <div className="flex-1 flex flex-col justify-start items-center">
        <div
          className={`w-full flex flex-col relative ${
            sectionId !== 7 &&
            sectionId !== 8 &&
            sectionId !== 9 &&
            sectionId !== 6
              ? 'max-w-4xl'
              : 'max-w-6xl'
          }`}
        >
          <ManufacturerFormBreadcrumb
            steps={steps}
            className="mb-2 w-full"
            currentStep={sectionId}
          />
          <div className="my-5 w-full flex flex-col justify-center items-center">
            <div className="max-w-3xl">{getSection(sectionId)}</div>
          </div>
        </div>
      </div>

      {/* Right Sidebar */}
      <div className="w-[27%] min-w-[300px] shadow-md">
        <div className="my-10 pl-8 mt-10 w-full">
          <RightSideBar setSectionId={navigateToSection} />
        </div>
      </div>
    </div>
  );
};

export default SupplierRegisterPage;
